import React, {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import './Usuario.css';
import api from '../../services/api';
import swal from 'sweetalert';
import imgStudentPortrait from '../../images/student_portrait.svg';

const Usuario = () => {

    const [userID, setUserID] = useState('');
    const [teacherName, setTeacherName] = useState('');
    const [imgPortrait, setImagePortrait] = useState();

    useEffect( () => {

        const initialize = async() => {
            try { 
                const response = await api.getUserInfo();
                const data = response.data;

                setTeacherName(data.nombre_completo);
                setUserID("(" + data.id_personal + ")");

            }catch (e){
                if(!e.response && !e.response.data) {
                    swal("Error", "Intente de nuevo más tarde.", "error");
                    return;
                }
            }
        }

        initialize();
        fotoAlumno();

    }, []);

    const fotoAlumno = async () => {
        try {
            const response = await api.getFotoPrefecto();
            const FOTO = response.data.data.FOTO;
            console.log(response.data)

            const arrayBuffer = new Uint8Array(FOTO.data);
            const base64String = btoa(
              arrayBuffer.reduce((data, byte) => data + String.fromCharCode(byte), '')
            );
            setImagePortrait(`data:image/jpeg;base64,${base64String}`);
        } catch (error) {
            setImagePortrait(imgStudentPortrait);

        }
    };

    return (
        <div className= "contenedor-usuario-prefectos hover-seccion">
            <div className= "seccion-boton-perfil-prefectos hover-subseccion">
                <Link to= "/">
                    <button className= "boton-cerrar-prefectos">
                        Cerrar sesión
                    </button>
                </Link>
            </div>
            <div className= "seccion-perfil-prefectos hover-subseccion">
                <div className= "seccion-img-perfil-prefectos">
                    <div className= "img-perfil-prefectos">
                        <img src={imgPortrait} alt="foto-prefecto" />
                    </div>
                </div>
            </div>
            <div className= "seccion-informacion-prefectos hover-subseccion">
                <div className= "seccion-docente-prefectos">
                    <div>
                        <div className="titulo-usuario-prefectos">
                            Prefecto:
                        </div>
                        <div className= "informacion-usuario-prefectos">
                            {teacherName} {userID}
                        </div>
                    </div>
                </div>
            </div>
      </div>
    );
  };

export default Usuario;
